import { Suspense } from 'react';
import ProductConfiguration from 'components/pages/product/product_configuration';
import PageLoader from 'components/common/page_loader';
import ShopTheme from 'theme/shop_theme';
// eslint-disable-next-line import/no-unassigned-import
import 'utilities/i18n';
import { FeatureFlags } from 'components/context/feature_flags';
import { datadogRum } from '@datadog/browser-rum';
import CustomQueryClientProvider from 'typescript/providers/custom_query_client_provider';
import { MarketManagers } from 'typescript/context/market_managers';
import { ProductContextProvider } from 'typescript/pages/product/contexts/product_context';
import ShopErrorBoundary from 'typescript/components/shop_error_boundary';
import { getInitialKioskProduct } from 'components/pages/product/product_with_software_add_on/utils';

const ProductApp = (props) => {
  // Set additional global context for Datadog RUM
  datadogRum.setGlobalContext(props.rumAttributes || {});

  const initialProduct = getInitialKioskProduct({
    product: props.product,
    alternatives: props.alternatives,
    alternativesMetadata: props.alternatives_metadata,
  });

  return (
    <ShopTheme>
      <ShopErrorBoundary appName="product">
        <Suspense fallback={<PageLoader delayMs={500} />}>
          <MarketManagers>
            <CustomQueryClientProvider>
              <FeatureFlags {...props}>
                <ProductContextProvider
                  {...props}
                  initialProduct={initialProduct}
                >
                  <ProductConfiguration {...props} />
                </ProductContextProvider>
              </FeatureFlags>
            </CustomQueryClientProvider>
          </MarketManagers>
        </Suspense>
      </ShopErrorBoundary>
    </ShopTheme>
  );
};

export default ProductApp;
